import React, { useState } from 'react';
import styles from 'routes/adminMobile/pages/AdminMobileStoreSale.module.css';
import Container from 'layouts/container/Container';
import { mainBgColor, mainBodyHeight, mainPadd, pageCommonGap1, pageCommonPadd, pageH1FontSize, pagePaddTopH } from '../constraints/AdminConst';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import P from 'components/P';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import AdminMobileSearchInput from 'routes/adminMobile/components/common/AdminMobileSearchInput';
import AdminMobileSortToggleBtn from 'routes/adminMobile/components/common/AdminMobileSortToggleBtn';
import AdminMobileSelect from 'routes/adminMobile/components/common/AdminMobileSelect';
import options from 'routes/adminMobile/commonVar/selectOption';
import AdminMobileSaleStatusList from 'routes/adminMobile/components/AdminMobileSaleStatusList';

// 점포별 매출 테스트 데이터
import testStoreSaleData from 'routes/adminMobile/commonVar/testStoreSaleData';
// const testStoreSaleData = [];

const AdminMobileStoreSale = () => {
    const [order, setOrder] = useState('desc'); // 기본값은 내림차순(order : desc)
    const [selectedOption, setSelectedOption] = useState('favorite'); // 선택된 옵션 상태
    // 테스트 데이터 기준으로 토글 기능 구현
    const [saleList, setSaleList] = useState([...testStoreSaleData]);
    // 검색어 상태 추가
    const [searchKeyword, setSearchKeyword] = useState('');

    // 정렬 기준 토글 버튼 기능
    const handleToggleChange = (ascending) => {
        const newOrder = ascending === 'asc' ? 'asc' : 'desc'; // asc 오름차순, desc 내림차순
        setOrder(newOrder); // 순서 업데이트
    
        // 선택된 옵션에 따라 매출 데이터 정렬
        let sortedSaleList;
        if (selectedOption === 'favorite') {
            // 즐겨찾기 순으로 정렬
            sortedSaleList = saleList.slice().sort((a, b) => {
                // storeFav가 true인 항목을 배열의 앞쪽으로 이동
                if (a.storeFav && !b.storeFav) {
                    return -1;
                } else if (!a.storeFav && b.storeFav) {
                    return 1;
                } else {
                    return 0;
                }
            });
        } else {
            // sales, revenue, registration 순으로 정렬
            sortedSaleList = saleList.slice().sort((a, b) => {
                // storeFav가 true인 항목을 배열의 앞쪽으로 이동
                if (a.storeFav && !b.storeFav) {
                    return -1;
                } else if (!a.storeFav && b.storeFav) {
                    return 1;
                } else {
                    // 각 옵션에 따른 기준에 따라 정렬
                    if (selectedOption === 'sales') {
                        return (newOrder === 'asc' ? a.storeAllSaleVol - b.storeAllSaleVol : b.storeAllSaleVol - a.storeAllSaleVol); // 총 판매량에 따라 오름차순 또는 내림차순으로 정렬
                    } else if (selectedOption === 'revenue') {
                        return (newOrder === 'asc' ? a.storeAllSales - b.storeAllSales : b.storeAllSales - a.storeAllSales); // 총 매출액에 따라 오름차순 또는 내림차순으로 정렬
                    } else if (selectedOption === 'registration') {
                        return (new Date(a.createDateTime) - new Date(b.createDateTime)) * (newOrder === 'asc' ? 1 : -1); // 등록일에 따라 오름차순 또는 내림차순으로 정렬
                    }
                }
            });
        }
    
        // 정렬된 배열을 상태로 설정
        setSaleList(sortedSaleList);
    };
    

    // 리스트 옵션 선택 기능
    const handleSelectChange = (value) => {
        setSelectedOption(value); // 선택된 옵션 업데이트

        // 항상 'desc'로 초기화
        setOrder('desc');

        // 선택된 옵션에 따라 매출 데이터 정렬
        let sortedSaleList;
        if (value === 'favorite') {
            // 즐겨찾기 순으로 정렬
            sortedSaleList = saleList.slice().sort((a, b) => {
                // storeFav가 true인 항목을 배열의 앞쪽으로 이동
                if (a.storeFav && !b.storeFav) {
                    return -1;
                } else if (!a.storeFav && b.storeFav) {
                    return 1;
                } else {
                    return 0;
                }
            });
        } else {
            // sales, revenue, registration 순으로 정렬
            sortedSaleList = saleList.slice().sort((a, b) => {
                // storeFav가 true인 항목을 배열의 앞쪽으로 이동
                if (a.storeFav && !b.storeFav) {
                    return -1;
                } else if (!a.storeFav && b.storeFav) {
                    return 1;
                } else {
                    // 각 옵션에 따른 기준에 따라 정렬
                    if (value === 'sales') {
                        return b.storeAllSaleVol - a.storeAllSaleVol; // 총 판매량에 따라 내림차순으로 정렬
                    } else if (value === 'revenue') {
                        return b.storeAllSales - a.storeAllSales; // 총 매출액에 따라 내림차순으로 정렬
                    } else if (value === 'registration') {
                        return new Date(b.createDateTime) - new Date(a.createDateTime); // 등록일에 따라 내림차순으로 정렬
                    }
                }
            });
        }

        // 정렬된 배열을 상태로 설정
        setSaleList(sortedSaleList);
    };
    

    // 검색 컴포넌트 기능
    // 검색어 입력 핸들러
    const handleSearchChange = (inputValue) => {
        setSearchKeyword(inputValue);
    };
    // storeFav에 따라 리스트 분리 및 병합하는 함수
    const mergeListByStoreFav = (list) => {
        const trueFavItems = list.filter(item => item.storeFav);
        const falseFavItems = list.filter(item => !item.storeFav);
        return [...trueFavItems, ...falseFavItems];
    };
    // 검색 결과를 필터링하여 반환하는 함수
    const filterSaleListBySearch = () => {
        if (!searchKeyword) {
            // 검색어가 없으면 전체 목록 반환
            return mergeListByStoreFav(saleList);
        } else {
            // 검색어가 있는 경우 검색 결과를 반환
            const filteredList = saleList.filter(item => item.storeName.includes(searchKeyword));
            return mergeListByStoreFav(filteredList);
        }
    };
    // 검색 결과를 저장할 변수
    const filteredSaleList = filterSaleListBySearch();
    

    // 즐겨찾기 토글 함수
    const toggleFavorite = (index) => {
        const updatedFilteredSaleList = [...filteredSaleList]; // 검색된 결과를 변경 가능한 배열로 복사
        updatedFilteredSaleList[index].storeFav = !updatedFilteredSaleList[index].storeFav;
        
        // storeFav가 true인 항목들을 배열의 앞쪽으로 이동
        const sortedSaleList = updatedFilteredSaleList.sort((a, b) => {
            // a가 storeFav이면서 b가 storeFav가 아닌 경우 a를 앞으로
            if (a.storeFav && !b.storeFav) {
                return -1;
            }
            // b가 storeFav이면서 a가 storeFav가 아닌 경우 b를 앞으로
            else if (!a.storeFav && b.storeFav) {
                return 1;
            }
            // 나머지는 testStoreSaleData 배열의 순서를 따름
            else {
                return testStoreSaleData.indexOf(a) - testStoreSaleData.indexOf(b);
            }
        });

        // 중복 제거를 위한 Set을 사용하여 storeId 기준으로 중복 제거
        const uniqueSaleList = Array.from(new Set([...testStoreSaleData, ...sortedSaleList]));

        // 정렬된 배열을 상태로 설정
        setSaleList(uniqueSaleList);
    };
    

    return (
        <div style={{paddingTop: pagePaddTopH}}>
            <Container padding={pageCommonPadd} height={mainBodyHeight}>
                <VerticalFlex gap={pageCommonGap1} backgroundColor={mainBgColor}>
                    <FlexChild alignItems="flex-start" height={"initial"} padding={mainPadd}>
                        {/* H1 헤더 */}
                        <P size={pageH1FontSize}>점포별 매출 현황</P>
                    </FlexChild>
                    <FlexChild height={"initial"} padding={mainPadd}>
                        {/* 검색창 */}
                        <AdminMobileSearchInput placeholder="점포명을 검색해보세요." onSearch={handleSearchChange} />
                    </FlexChild>
                    <FlexChild height={"initial"} padding={mainPadd}>
                        {/* 정렬 기준 */}
                        <HorizontalFlex justifyContent="flex-end" gap="1.5rem">
                            {/* selectedOption이 'favorite'가 아닌 경우에만 표시 */}
                            {selectedOption !== 'favorite' && (
                                <FlexChild width="auto">
                                    {/* 오름차순(과거 기준), 내림차순(최신 기준) 토글 버튼 */}
                                    <AdminMobileSortToggleBtn onChange={handleToggleChange} order={order} />
                                </FlexChild>
                            )}
                            <FlexChild width="auto">
                                {/* 기본 정렬 : 내림차순(최신 순서) */}
                                <AdminMobileSelect options={options} onChange={handleSelectChange} />
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        {/* 매장 리스트 출력 */}
                        <AdminMobileSaleStatusList saleList={filteredSaleList} toggleFavorite={toggleFavorite} />
                    </FlexChild>
                </VerticalFlex>
            </Container>
        </div>
    );
};

export default AdminMobileStoreSale;